import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin'

import FilterComponent from '../../components/Filter'

const B2BPoolAmountFilter = props => (
  <FilterComponent {...props}>
    <ReferenceInput
      label="Organization"
      source="organizationId"
      reference="b2b-organizations"
      alwaysOn>
      <AutocompleteInput
        optionText="name"
        filterToQuery={searchText => ({
          name: { $iLike: `%${searchText}%` },
        })}
      />
    </ReferenceInput>
  </FilterComponent>
)

const B2BPoolAmountList = props => (
  <List
    {...props}
    filters={<B2BPoolAmountFilter />}
    bulkActionButtons={false}
    sort={{ field: 'createdAt', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <NumberField label="ID" source="id" />
      <TextField label="Organization" source="props.organizationName" />
      <NumberField label="Organization ID" source="props.organizationId" />
      <NumberField label="Month" source="props.month" />
      <NumberField
        label="Year"
        source="props.year"
        options={{ useGrouping: false }}
      />
      <NumberField
        label="Pool Amount"
        source="props.poolAmount"
        options={{
          style: 'currency',
          currency: 'VND',
          currencyDisplay: 'symbol',
        }}
        locales="vi-VN"
      />
      <NumberField
        label="Contract Amount"
        source="props.contractAmount"
        options={{
          style: 'currency',
          currency: 'VND',
          currencyDisplay: 'symbol',
        }}
        locales="vi-VN"
      />
      <NumberField label="Days In Period" source="props.daysInPeriod" />
      <DateField label="Created At" source="createdAt" showTime />
      <DateField label="Updated At" source="updatedAt" showTime />
    </Datagrid>
  </List>
)

export default B2BPoolAmountList
